import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Appointment } from '../appointment';

@Component({
  selector: 'mc-appointment-form',
  templateUrl: './appointment-form.component.html',
  styleUrls: ['./appointment-form.component.scss']
})
export class AppointmentFormComponent implements OnInit {

  @Output() canceled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saved: EventEmitter<Appointment> = new EventEmitter<Appointment>();
  @Input() public appointment: Appointment;

  constructor(private notifService: ToastrService) { }

  ngOnInit() {
    if (!this.appointment) {
      this.appointment = new Appointment();
      this.appointment.date = new Date();
    }
  }

  save(): void {
    const a = this.appointment;
    if (a.main_complaint || a.current_desease_history || a.conduct ||
        a.conduct || a.diagnostic_hypothesis || a.exams_results ||
        a.family_history || a.personal_history || a.physical_exam ||
        a.other) {
      this.saved.emit(this.appointment);

    } else {
      this.notifService.error('Ao menos um campo deve ser preenchido');
    }
  }

  cancel(): void {
    this.canceled.emit(true);
  }
}
